import {
  IAddElementTemplateToJobPayload,
  IElement,
  IElementAutocompleteRequestPayload,
  IElementListRequestPayload,
  ISaveElementAsTemplatePayload,
  IUpsertElementComponentNotePayload,
  IUpsertElementComponentNotesPayload,
  IUpsertElementPayload,
} from 'bom/types';
import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse, IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';

export const getElements = async (
  requestPayload: IElementListRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IElement>> => {
  const { data } = await partfinitiClient.get(
    `/bom/element-list/elements?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IElement>(data.data, data.recordsFiltered, data.totals, {
    pendingCliJobs: data?.pending_cli_jobs,
  });
};

export const getElementsAutocomplete = async (
  requestPayload?: IElementAutocompleteRequestPayload,
  signal?: AbortSignal
) => {
  const { data } = await partfinitiClient.get(
    `/bom/element/autocomplete?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IElement>(data.elements, data.total_count);
};

export const getElementTemplatesAutocomplete = async (
  requestPayload?: IRequestPayload,
  signal?: AbortSignal
) => {
  const { data } = await partfinitiClient.get(
    `/element/template/autocomplete?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IElement>(data.element_templates, data.total_count);
};

export const upsertElement = async (data: IUpsertElementPayload) =>
  partfinitiClient.postForm('/bom/element/save', data, {
    includeNullValues: true,
  });

export const addElementTemplateToJob = async (data: IAddElementTemplateToJobPayload) =>
  partfinitiClient.postForm('/element/template/add-to-bom', data, {
    includeNullValues: true,
  });

export const upsertElementComponentNote = async (data: IUpsertElementComponentNotePayload) =>
  partfinitiClient.postForm('/bom/element-component-note-edit/save', data);

export const removeElementComponentNotes = async (data: { ids: number[] }) =>
  partfinitiClient.postForm('/bom/element-component-note-edit/remove', data);

export const upsertElementComponentNotes = async (data: IUpsertElementComponentNotesPayload) =>
  partfinitiClient.postForm('/bom/element-component-note-edit/save-bulk', data);

export const saveElementAsTemplate = async (data: ISaveElementAsTemplatePayload) =>
  partfinitiClient.postForm('/bom/element/save-as-template', data, {
    includeNullValues: true,
  });
